import React from "react";

const AppContext = React.createContext({ showIntercom: false, setIntercom: (show: boolean) => {} });

export default AppContext;
